import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LucideAstroid } from '@lucide/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { PmIconComponent } from '@libs/ui';
import { ChatStateService } from '../../services/chat-state.service';

@Component({
  selector: 'pm-agent-chat-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PmIconComponent, TranslatePipe],
  template: `
    <button
      type="button"
      safeButtonUsage
      class="inline-flex h-8 min-w-20 items-center gap-1.5 rounded-lg border py-0 pl-3 pr-4 text-center text-xs font-normal leading-snug text-content-title transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-content-interactive-default"
      [class]="
        chat.isOpen()
          ? 'border-border-interactive-default bg-surface-brand-default'
          : 'border-border-interactive-default bg-surface hover:bg-surface-neutral-subdued'
      "
      [attr.aria-pressed]="chat.isOpen()"
      (click)="chat.toggle()"
    >
      <pm-icon
        [icon]="LucideAstroid"
        size="sm"
        class="shrink-0 text-content-interactive-default"
      />
      <span class="whitespace-nowrap">{{
        'navigation.toolbar.askAi' | translate
      }}</span>
    </button>
  `,
})
export class AgentChatButtonComponent {
  protected readonly chat = inject(ChatStateService);

  protected readonly LucideAstroid = LucideAstroid;
}
